import PercentageValue from "@/components/tableElements/PercentageValue";
import { CurrencyValue } from "@/components/tableElements";
export default {
  name: "PpcBAProductMarginCell",
  components: {
    PercentageValue,
    CurrencyValue
  },
  props: {
    value: {
      type: Number
    },
    currency: {
      type: String
    },
    percentage_value: {
      type: String
    }
  }
};